/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';

import * as l10n from './log-cinematic-sub-section-jwt.l10n';
import { TrafficLogCinematicStore } from '../../../traffic-logs/traffic-log-cinematic/traffic-log-cinematic.store';

import './log-cinematic-sub-section-jwt.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;
const { ...globalL10nKeys } = globalL10n;

/**
 * @description
 *     Component for displaying the JWT sub-section in the Authentication section under traffic log cinematic view.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-sub-section-jwt',
    templateUrl: './log-cinematic-sub-section-jwt.component.html',
})
export class LogCinematicSubSectionJwtComponent {
    public readonly jwtLog$ = this.logCinematicStore.jwtLog$;

    public readonly globalL10nKeys = globalL10nKeys;

    public readonly l10nKeys = l10nKeys;

    constructor(
        public readonly logCinematicStore: TrafficLogCinematicStore,
        l10nService: L10nService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }
}
